import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const names = ['Lucía', 'Martín', 'Camila', 'Santiago', 'Valentina', 'Mateo', 'Sofía', 'Nicolás', 'Florencia', 'Agustín', 'Carolina', 'Federico', 'Julieta', 'Tomás', 'María', 'Facundo', 'Micaela', 'Gonzalo', 'Paula', 'Diego'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Miguel de Tucumán', 'Paraná', 'Jujuy'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNext = () => {
      // Random delay between 8 and 12 seconds
      const delay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      showTimeout = setTimeout(() => {
        const randomName = names[Math.floor(Math.random() * names.length)];
        const randomCity = cities[Math.floor(Math.random() * cities.length)];
        setData({
          name: randomName,
          city: randomCity
        });
        setIsVisible(true);
        // Hide after 4 seconds
        hideTimeout = setTimeout(() => {
          setIsVisible(false);
          scheduleNext(); // Schedule the next one only after hiding
        }, 4000);
      }, delay);
    };
    // Start the cycle
    scheduleNext();
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-157">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white rounded-lg shadow-xl border border-emerald-100 p-4 flex items-center gap-4" data-id="element-158">
          <div className="bg-emerald-100 p-2 rounded-full text-emerald-600 flex-shrink-0" data-id="element-159">
            <ShoppingCart size={20} data-id="element-160" />
          </div>
          <p className="text-sm text-gray-700 font-medium" data-id="element-161">
            <span className="font-bold text-emerald-800" data-id="element-162">{data.name}</span> de{' '}
            {data.city} acaba de comprar el Sistema PRO
          </p>
        </motion.div>}
    </AnimatePresence>;
}